// Magic Afro — self-contained wishlist (no app required).
//
// Replaces the missing WishlistHero/Flits app embed with a browser-side
// wishlist that matches the La Belle Boucle reference layout:
//   - a heart toggle on every product card + the PDP,
//   - a live count badge on the header heart,
//   - a /pages/wishlist page rendering saved products as cards (badges,
//     remove ✕, add-to-cart bag, price with compare-at + discount %).
//
// Persistence is localStorage (key `magicWishlist` = JSON array of product
// handles). The wishlist page fetches /products/<handle>.js for fresh
// title/price/image/tags, so prices and promos never go stale.
//
// The wishlist PAGE works two ways, so it needs NO custom theme template:
//   1. via sections/magic-wishlist-page.liquid (templates/page.wishlist.json), or
//   2. on ANY page whose URL is /pages/wishlist — this script builds the styled
//      page itself (so an ordinary default-template "Wishlist" page works too).
(function () {
  if (window.MagicWishlist) return;

  var KEY = 'magicWishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  // ---- Wishlist Hero backend adapter (2026-07-14, "Option A") ---------------
  // OUR design, WLH's data engine. localStorage stays the instant cache and
  // the offline fallback; the WLH SDK (window.WishListHero_SDK, loaded by the
  // app embed with auto-UI injection DISABLED) is the source of truth when
  // reachable. Proven SDK contract (discovered + live-fire tested 2026-07-14):
  //   hash = GetWishListHash(payload)              -> string (required)
  //   AddWishListItem({...payload, WishlistHash})  -> {ok:true}
  //   DeleteWishListItem({...payload, WishlistHash}) -> {ok:true}
  //   GetWishListItemsFromServer()                 -> [{ProductHandle, ...}]
  //   payload = {ProductId, ProductVariantId, ProductTitle, ProductLink,
  //              ProductPrice (EUR number), ProductImage} — all from
  //              /products/<handle>.js (fetchProduct below).
  // If the SDK never appears (app removed / blocked), everything degrades to
  // the original pure-localStorage behavior — no errors, no UI change.
  function sdk() { return window.WishListHero_SDK || null; }

  function wlhPayload(productData, handle) {
    return {
      ProductId: String(productData.id),
      ProductVariantId: String((productData.variants && productData.variants[0] && productData.variants[0].id) || ''),
      ProductTitle: productData.title || handle,
      ProductLink: location.origin + '/products/' + handle,
      ProductPrice: (Number(productData.price) || 0) / 100,
      ProductImage: productData.featured_image || ''
    };
  }

  function wlhSend(handle, op) {
    var s = sdk();
    if (!s) return; // offline fallback: local-only, like before the switch
    fetchProduct(handle).then(function (data) {
      if (!data) return;
      var payload = wlhPayload(data, handle);
      return Promise.resolve(s.GetWishListHash(payload)).then(function (hash) {
        payload.WishlistHash = hash;
        var call = op === 'add' ? s.AddWishListItem(payload) : s.DeleteWishListItem(payload);
        return Promise.resolve(call);
      }).then(function (res) {
        if (res && res.ok === false) console.warn('[magic-wishlist] WLH ' + op + ' refused:', res);
      });
    }).catch(function (e) { console.warn('[magic-wishlist] WLH ' + op + ' failed:', e); });
  }

  // silent local mutation (no server echo) — used by the boot-time server sync
  function applyLocal(h, on) {
    var l = read(), i = l.indexOf(h), dirty = false;
    if (on && i === -1) { l.push(h); dirty = true; }
    if (!on && i !== -1) { l.splice(i, 1); dirty = true; }
    if (dirty) write(l);
    return dirty;
  }

  // boot-time reconciliation: server wins for existence, local-only items are
  // pushed UP (migrates wishlists saved before the WLH switch), then the
  // merged union becomes the local cache.
  var wlhSynced = false;
  function wlhBootSync() {
    var s = sdk();
    if (!s || wlhSynced) return;
    wlhSynced = true;
    Promise.resolve(s.GetWishListItemsFromServer()).then(function (items) {
      if (!Array.isArray(items)) return;
      var serverHandles = items.map(function (i) { return i && i.ProductHandle; }).filter(Boolean);
      var local = read(), dirty = false;
      // 1) upload local-only handles (pre-switch wishlists) to the server
      local.forEach(function (h) {
        if (serverHandles.indexOf(h) === -1) wlhSend(h, 'add');
      });
      // 2) adopt server-only handles locally
      serverHandles.forEach(function (h) {
        if (applyLocal(h, true)) dirty = true;
      });
      if (dirty) changed();
    }).catch(function (e) { console.warn('[magic-wishlist] WLH sync failed:', e); });
  }
  (function waitForSdk(tries) {
    if (sdk()) return wlhBootSync();
    if (tries <= 0) return; // no SDK -> stay pure-localStorage
    setTimeout(function () { waitForSdk(tries - 1); }, 500);
  })(24); // up to ~12s for the app embed to load

  var MW = {
    list: function () { return read(); },
    has: function (h) { return read().indexOf(h) !== -1; },
    count: function () { return read().length; },
    add: function (h) { var l = read(); if (l.indexOf(h) === -1) { l.push(h); write(l); changed(); wlhSend(h, 'add'); } },
    remove: function (h) { var l = read(); var i = l.indexOf(h); if (i !== -1) { l.splice(i, 1); write(l); changed(); wlhSend(h, 'remove'); } },
    toggle: function (h) { this.has(h) ? this.remove(h) : this.add(h); }
  };
  window.MagicWishlist = MW;

  function changed() {
    syncHearts();
    syncCount();
    renderPage();
    document.dispatchEvent(new CustomEvent('magic-wishlist:change', { detail: { list: read() } }));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---- hearts (cards + PDP) -------------------------------------------------
  function syncHearts() {
    var set = read();
    document.querySelectorAll('[data-wl-heart]').forEach(function (btn) {
      var on = set.indexOf(btn.getAttribute('data-wl-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = btn.querySelector('.magic-wl-heart__label');
      if (lbl) lbl.textContent = on ? 'Dans ma liste de souhaits' : 'Ajouter à ma liste de souhaits';
    });
  }

  // Capture-phase: a heart click toggles the wishlist and never opens the card
  // link / navigates.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var heart = t.closest('[data-wl-heart]');
    if (!heart) return;
    e.preventDefault();
    e.stopPropagation();
    var h = heart.getAttribute('data-wl-handle');
    if (h) MW.toggle(h);
  }, true);

  // ---- header count badge ---------------------------------------------------
  function syncCount() {
    var n = read().length;
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
  }

  // ---- money / helpers ------------------------------------------------------
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
  }
  function hasTag(tags, names) {
    if (!tags) return false;
    var low = tags.map(function (t) { return String(t).toLowerCase(); });
    for (var i = 0; i < names.length; i++) if (low.indexOf(names[i]) !== -1) return true;
    return false;
  }
  function isNew(data) {
    if (hasTag(data.tags, ['nouveau', 'nouveauté', 'nouveaute', 'new'])) return true;
    if (data.created_at) {
      var age = Date.now() - new Date(data.created_at).getTime();
      if (age > 0 && age < 45 * 864e5) return true;
    }
    return false;
  }

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function cardHTML(d) {
    // Only an AVAILABLE variant may be offered (Fahad 2026-07-24). The old
    // `|| variants[0]` fallback meant a fully sold-out wishlist item still
    // rendered a working bag button and could be added to the cart.
    var v = (d.variants || []).filter(function (x) { return x.available; })[0] || {};
    var soldOut = !v.id;
    var onSale = d.compare_at_price && d.compare_at_price > d.price;
    var disc = onSale ? Math.round((1 - d.price / d.compare_at_price) * 100) : 0;

    var badges = '';
    if (hasTag(d.tags, ['coup de coeur', 'coup-de-coeur', 'coup_de_coeur', 'coups de coeur', 'bestseller', 'best-seller'])) {
      badges += '<span class="wl-badge wl-badge--coup">Coup de coeur</span>';
    }
    if (isNew(d)) badges += '<span class="wl-badge wl-badge--new">Nouveau</span>';
    if (onSale) badges += '<span class="wl-badge wl-badge--promo">Promotion</span>';
    // Sold out: the bag button is suppressed below (no available variant), so
    // say WHY — otherwise the card just silently loses its add button.
    if (soldOut) badges += '<span class="wl-badge wl-badge--soldout">Épuisé</span>';

    var price = onSale
      ? '<span class="wl-card__price-sale">' + money(d.price) + '</span>' +
        '<span class="wl-card__price-was">' + money(d.compare_at_price) + '</span>' +
        '<span class="wl-card__price-disc">-' + disc + '%</span>'
      : '<span class="wl-card__price-reg">' + money(d.price) + '</span>';

    var img = d.featured_image
      ? '<img src="' + esc(sized(d.featured_image, 600)) + '" alt="' + esc(d.title) + '" loading="lazy" width="600" height="600">'
      : '<span class="wl-card__noimg"></span>';

    return '' +
      '<article class="wl-card" data-wl-item="' + esc(d.handle) + '" role="listitem">' +
        '<div class="wl-card__media">' +
          (badges ? '<div class="wl-card__badges">' + badges + '</div>' : '') +
          '<button type="button" class="wl-card__remove" data-wl-remove="' + esc(d.handle) + '" aria-label="Retirer de la liste">' +
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<a class="wl-card__imglink" href="' + esc(d.url) + '" aria-label="' + esc(d.title) + '">' + img + '</a>' +
          (v.id
            ? '<button type="button" class="wl-card__bag" data-wl-bag="' + v.id + '" aria-label="Ajouter au panier">' +
                // Bag WITH a "+" — the old plain bag read as a trash can at
                // 20px (Fahad 2026-07-23: mobile users thought there was no
                // add-to-cart). The plus makes the intent unmistakable.
                '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true"><path d="M5.5 8.5h13l-1.1 11.5H6.6L5.5 8.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M12 11.5v5M9.5 14h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
              '</button>'
            : '') +
        '</div>' +
        '<a class="wl-card__title" href="' + esc(d.url) + '">' + esc(d.title) + '</a>' +
        '<div class="wl-card__price">' + price + '</div>' +
      '</article>';
  }

  // ---- wishlist page: detect, build (default-template fallback), style ------
  function isWishlistPage() {
    return /\/pages\/wishlist(?:[\/?#]|$)/i.test(location.pathname);
  }

  var SHARE_SVG = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true">' +
    '<circle cx="18" cy="5" r="2.4" stroke="currentColor" stroke-width="1.6"/>' +
    '<circle cx="6" cy="12" r="2.4" stroke="currentColor" stroke-width="1.6"/>' +
    '<circle cx="18" cy="19" r="2.4" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="M8.1 10.9l7.8-4.5M8.1 13.1l7.8 4.5" stroke="currentColor" stroke-width="1.6"/></svg>';

  var WL_PAGE_CSS = '' +
    '.magic-wl-page{padding-block:28px 64px;}' +
    '.magic-wl-page__head{display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:28px;}' +
    '.magic-wl-page__title{font-size:clamp(2rem,4vw,2.75rem);font-weight:700;margin:0;color:#1f1f1a;}' +
    '.magic-wl-share{-webkit-appearance:none;appearance:none;border:0;background:transparent;color:#323328;cursor:pointer;padding:6px;line-height:0;border-radius:999px;}' +
    '.magic-wl-share:hover{color:#d8775f;}' +
    '.magic-wl-empty{font-size:1.05rem;color:#5b5b50;}' +
    '.magic-wl-empty__link{color:#d8775f;text-decoration:underline;text-underline-offset:3px;margin-inline-start:4px;}' +
    '.magic-wl-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:22px;}' +
    '@media screen and (max-width:989px){.magic-wl-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:16px;}}' +
    '.wl-card{display:flex;flex-direction:column;}' +
    '.wl-card__media{position:relative;background:#f6ece4;border-radius:14px;overflow:hidden;aspect-ratio:1/1;}' +
    '.wl-card__imglink{display:block;width:100%;height:100%;}' +
    '.wl-card__media img{width:100%;height:100%;object-fit:contain;display:block;padding:8%;}' +
    '.wl-card__noimg{display:block;width:100%;height:100%;}' +
    '.wl-card__badges{position:absolute;top:12px;left:12px;z-index:2;display:flex;flex-direction:column;align-items:flex-start;gap:6px;}' +
    '.wl-badge{font-size:.6875rem;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#fff;padding:4px 10px;border-radius:999px;line-height:1.1;}' +
    '.wl-badge--coup{background:#d68a76;}.wl-badge--new{background:#c7b89b;}.wl-badge--promo{background:#d8775f;}' +
    '.wl-card__remove{position:absolute;top:12px;right:12px;z-index:3;-webkit-appearance:none;appearance:none;border:0;cursor:pointer;width:30px;height:30px;border-radius:999px;background:rgba(255,255,255,.6);color:#3a3a32;display:inline-flex;align-items:center;justify-content:center;transition:background-color .15s ease;}' +
    '.wl-card__remove:hover{background:#fff;color:#d8775f;}' +
    '.wl-card__bag{position:absolute;right:14px;bottom:14px;z-index:3;-webkit-appearance:none;appearance:none;border:0;cursor:pointer;width:46px;height:46px;border-radius:999px;background:#d18c79;color:#fff;display:inline-flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,.14);transition:transform .12s ease,background-color .15s ease;}' +
    '.wl-card__bag:hover{background:#c47b67;}' +
    '.wl-card__bag.is-loading{opacity:.6;pointer-events:none;}' +
    '.wl-card__bag.is-done{background:#4c9a6a;}.wl-card__bag.is-done svg{display:none;}.wl-card__bag.is-done::after{content:"\\2713";font-size:22px;line-height:1;}' +
    '.wl-card__title{margin-top:14px;font-size:1.0625rem;font-weight:600;color:#1f1f1a;text-decoration:none;line-height:1.3;}' +
    '.wl-card__title:hover{color:#d8775f;}' +
    '.wl-card__price{margin-top:8px;display:flex;align-items:center;gap:10px;flex-wrap:wrap;font-size:1.0625rem;}' +
    '.wl-card__price-reg{font-weight:600;color:#1f1f1a;}' +
    '.wl-card__price-sale{font-weight:700;color:#d8775f;}' +
    '.wl-card__price-was{color:#9a958c;text-decoration:line-through;font-size:.95em;}' +
    '.wl-card__price-disc{background:#d8775f;color:#fff;font-size:.75rem;font-weight:700;padding:2px 7px;border-radius:6px;}';

  function ensurePageCSS() {
    if (document.getElementById('magic-wl-page-css')) return;
    var s = document.createElement('style');
    s.id = 'magic-wl-page-css';
    s.textContent = WL_PAGE_CSS;
    document.head.appendChild(s);
  }

  // Build the styled wishlist page into the main content when we are on
  // /pages/wishlist but the dedicated section wasn't rendered (ordinary page).
  function ensureWishlistPageDom() {
    if (!isWishlistPage()) return;
    // Marks the wishlist page for CSS gating: the default page template
    // (page.json) carries a reassurance-band section that stays hidden on
    // every other default page (see GROUP 21 in magic-css-overrides). The
    // page can't use its dedicated page.wishlist template until the theme
    // is PUBLISHED (the admin template picker only lists the published
    // theme's templates), so this class is the wishlist marker until then.
    document.body.classList.add('is-wishlist-page');
    if (document.querySelector('[data-wl-grid]')) return; // section already present
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var existingH1 = main.querySelector('h1');
    var title = (existingH1 && existingH1.textContent.trim()) || 'Wishlist';
    // Target the section that holds the page title — NOT the (invisible)
    // magic-css-overrides style section, which is usually first in the DOM.
    var host = (existingH1 && existingH1.closest('.shopify-section')) ||
      main.querySelector('.shopify-section:not(.magic-css-overrides-section)') ||
      main.querySelector('.shopify-section') || main;
    ensurePageCSS();
    var wrap = document.createElement('div');
    wrap.className = 'magic-wl-page page-width section';
    wrap.setAttribute('data-wl-page', '');
    wrap.innerHTML =
      '<div class="magic-wl-page__head">' +
        '<h1 class="magic-wl-page__title">' + esc(title) + '</h1>' +
        '<button type="button" class="magic-wl-share" aria-label="Partager ma liste" data-wl-share>' + SHARE_SVG + '</button>' +
      '</div>' +
      '<p class="magic-wl-empty" data-wl-empty hidden>Votre liste de souhaits est vide. ' +
        '<a class="magic-wl-empty__link" href="/collections/all">Découvrir nos produits</a></p>' +
      '<div class="magic-wl-grid" data-wl-grid role="list" aria-live="polite"></div>';
    host.innerHTML = '';
    host.appendChild(wrap);
  }

  // ---- wishlist page render -------------------------------------------------
  var rendering = false;
  function renderPage() {
    ensureWishlistPageDom();
    var grid = document.querySelector('[data-wl-grid]');
    if (!grid) return;
    ensurePageCSS();
    var empty = document.querySelector('[data-wl-empty]');
    var handles = read();

    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (rendering) return;
    rendering = true;

    Promise.all(handles.map(fetchProduct)).then(function (items) {
      rendering = false;
      // keep wishlist order; drop products that no longer exist (404 → null)
      var live = [];
      var keepHandles = [];
      items.forEach(function (d, i) {
        if (d && d.handle) { live.push(d); keepHandles.push(handles[i]); }
      });
      if (keepHandles.length !== handles.length) { write(keepHandles); syncCount(); }
      if (!live.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
      grid.innerHTML = live.map(cardHTML).join('');
    });
  }

  // add-to-cart (bag button on the wishlist page)
  function addToCart(variantId, btn) {
    btn && btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1600); }
      // Feedback used to be invisible (Fahad 2026-07-23, "on mobile it
      // doesn't work"): the old 'cart:refresh' event means nothing to
      // Horizon (its cart-icon listens for 'cart:update' and SETS the
      // bubble to detail.data.itemCount ?? 0), and the old drawer-opener
      // selector missed the real trigger. Now: fetch the cart, dispatch
      // the proper 'cart:update' (bubble updates), then open the drawer
      // via its actual trigger so the customer SEES the added item.
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; })
        .then(function (cart) {
          // Only dispatch when the cart snapshot ARRIVED: an itemCount-less
          // 'cart:update' makes Horizon's cart-icon coerce `?? 0` and HIDE
          // the badge right after a successful add (pre-launch review
          // 2026-07-23). A stale badge beats a wrong "0".
          if (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'magic-wishlist',
                data: {
                  source: 'magic-wishlist',
                  itemCount: cart.item_count
                }
              }
            }));
          }
          document.dispatchEvent(new CustomEvent('cart:refresh')); // legacy listeners
          var opener = document.querySelector('[data-testid="cart-drawer-trigger"]') ||
                       document.querySelector('[on\\:click*="cart-drawer"], a[href$="/cart"].header-actions__action');
          if (opener && opener.click) try { opener.click(); } catch (e) {}
        });
    }).catch(function () {
      if (btn) btn.classList.remove('is-loading');
      window.location.href = '/cart';
    });
  }

  function share() {
    var url = location.href;
    if (navigator.share) { navigator.share({ title: 'Ma liste de souhaits', url: url }).catch(function () {}); }
    else if (navigator.clipboard) { navigator.clipboard.writeText(url).catch(function () {}); }
  }

  // delegated clicks on the wishlist page (remove ✕ + add-to-cart bag + share)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var rm = e.target.closest('[data-wl-remove]');
    if (rm) { e.preventDefault(); MW.remove(rm.getAttribute('data-wl-remove')); return; }
    var bag = e.target.closest('[data-wl-bag]');
    if (bag) { e.preventDefault(); addToCart(bag.getAttribute('data-wl-bag'), bag); return; }
    var sh = e.target.closest('[data-wl-share]');
    if (sh) { e.preventDefault(); share(); }
  });

  // ---- boot + keep in sync across SPA-ish morphs ---------------------------
  function boot() { syncHearts(); syncCount(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-sync when the Section Rendering API injects new cards (collections,
  // search, recommendations) or the theme editor reloads a section.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('[data-wl-heart]') || n.querySelector && n.querySelector('[data-wl-heart]'))) {
          syncHearts();
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', boot);

  // cross-tab sync
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncHearts(); syncCount(); renderPage(); } });
})();
